import localStorageService from '@mm/utils/src/local-storage-service';
import store from '@mm/state';
import { shopifyRoutesPaths } from './constants';
export const isShopifyRoute = () =>
  shopifyRoutesPaths.some(path => window.location.pathname === path);

export const setIsShopifyApp = () => {
  return localStorageService.setItem('shopify', Date.now().toString());
};
export const getIsShopifyApp = () => {
  const session = store?.getState()?.session?.session;
  const shopifyFootprint = !!localStorageService.getItem('shopify');

  return shopifyFootprint || isShopifyRoute() || session?.shops?.length;
};

export const removeShopifyMark = () => {
  return localStorage.removeItem('shopify');
};
